import * as sentry from '@sentry/nextjs';
import React, { useCallback, useEffect } from 'react';

import { verifyIdentity } from '../../../../api/manifold/verification';
import { useAuth } from '../../../../providers';
import { network, WidgetProps } from '../config';

// https://docs.manifold.xyz/v/manifold-for-developers/resources/widgets/marketplace-widgets/widgets/listing-widgets#m-listing-bid-form-rich
export const BidFormRich = ({ listingId }: WidgetProps) => {
  const { user } = useAuth();

  const handleVerifyIdentity = useCallback(
    (event: CustomEvent<{ transactionId: string; buyerAddress: string }>) => {
      if (!user?.email || !listingId) return;

      const data = {
        'email': user.email,
        'buyerAddress': event.detail.buyerAddress,
        'listingId': Number(listingId),
      };

      verifyIdentity(data)
        .then((response) => response.json())
        .then((results: { signature: string }) => {
          const e = new CustomEvent('m-marketplace_tx_id_complete', {
            detail: {
              transactionId: event.detail.transactionId,
              verified: true,
              identityVerifierData: results.signature,
            },
          });
          window.dispatchEvent(e);
        })
        .catch((err) => {
          sentry.captureException(err);
        });
    },
    [listingId, user],
  );

  useEffect(() => {
    window.addEventListener('m-marketplace_tx_id_verify', handleVerifyIdentity);
    return () => {
      window.removeEventListener(
        'm-marketplace_tx_id_verify',
        handleVerifyIdentity,
      );
    };
  }, [handleVerifyIdentity]);

  /**
   * window.mMarketplaceStore.subscribeAction((action, state) => {
   *   console.log(action.type)
   *   console.log(action.payload)
   * })
   */

  return (
    <div
      data-emits-identity-verify="true"
      data-id={listingId}
      data-network={network}
      data-widget="m-listing-bid-form-rich"
      id="bid-form"
    />
  );
};
